import { observer } from "mobx-react";
import { docInstanceLabel, DocInstanceId } from "~/document";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select";
import { cn } from "~/lib/utils";

interface Props {
  value: DocInstanceId;
  onChange: (newValue: DocInstanceId) => void;
  selectProps?: any;
  className?: string;
}

const options = Object.entries(docInstanceLabel).map(([value, label]) => ({
  label,
  value,
}));

const DocInstanceSelect = observer((props: Props) => {
  const hasValue = props.value !== undefined && props.value !== null && !Number.isNaN(+props.value);
  return (
    <Select
      value={hasValue ? String(props.value) : undefined}
      onValueChange={(v) => props.onChange(v as unknown as DocInstanceId)}
      disabled={props.selectProps?.disabled}
    >
      <SelectTrigger className={cn("w-full", props.className)}>
        <SelectValue placeholder="Nothing selected" />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

export default DocInstanceSelect;
